import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import { Folder } from 'models/types';

type ArchivedSegment = Folder;

type UseArchivedSegmentsListParams = {
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<ArchivedSegment[], Error>;
};

const useArchivedSegmentsList = ({ searchTerm, reactQueryOptions }: UseArchivedSegmentsListParams = {}) => {
    const axiosOptions = {
        ...(searchTerm && { params: { searchTerm } }),
    };

    return useQuery(
        [QueryKeys.ARCHIVED_SEGMENTS, searchTerm],
        CuredApiPaths.SEGMENTS_ARCHIVED_LIST,
        reactQueryOptions,
        axiosOptions
    );
};

export default useArchivedSegmentsList;
